@if (dice(); as d) {
  <rid-modal-background class="pointer-events-auto z-10" [blur]="true" />

  <!-- Center dice (for rolling) -->
  <div
    class="pointer-events-auto absolute inset-0 z-20 grid place-items-center select-none"
    [style.transform-origin]="{ EMERALD: 'right top', BLUE: 'right bottom', ORANGE: 'left bottom' }[d.color]"
    animate.enter="wait-500 anim-slide-from-bottom"
    animate.leave="anim-pop-out"
    ridSfx="SHORT_SLIDE"
    [ridSfxAnimations]="['pop-out']"
  >
    <div class="relative">
      <rid-dice
        #centerDice
        [color]="
          {
            EMERALD: 'emerald-500',
            BLUE: 'blue-500',
            ORANGE: 'orange-500',
          }[d.color]
        "
      >
        <div face="1">
          <img [src]="d.faces?.[0] ?? '/dice/1.png'" alt="" (dragstart)="(false)" />
        </div>
        <div face="2">
          <img [src]="d.faces?.[1] ?? '/dice/2.png'" alt="" (dragstart)="(false)" />
        </div>
        <div face="3">
          <img [src]="d.faces?.[2] ?? '/dice/3.png'" alt="" (dragstart)="(false)" />
        </div>
        <div face="4">
          <img [src]="d.faces?.[3] ?? '/dice/4.png'" alt="" (dragstart)="(false)" />
        </div>
        <div face="5">
          <img [src]="d.faces?.[4] ?? '/dice/5.png'" alt="" (dragstart)="(false)" />
        </div>
        <div face="6">
          <img [src]="d.faces?.[5] ?? '/dice/6.png'" alt="" (dragstart)="(false)" />
        </div>
      </rid-dice>

      @if (showReadingHint()) {
        <p
          class="font-family-din text-text-primary absolute top-full left-1/2 mt-8 -translate-x-1/2 rounded-full bg-white/85 px-6 py-2 text-2xl font-bold tracking-wide whitespace-nowrap shadow-lg backdrop-blur-sm"
          animate.enter="anim-pop-in"
          animate.leave="anim-fade-out"
        >
          {{ $textsService.getText('expression-dice.result-instruction') }}
        </p>
      }
    </div>
  </div>
}

<!-- numeric dice -->
<rid-dice-slot
  class="absolute top-14 right-4"
  [value]="numericDice()"
  color="EMERALD"
  [togglable]="$diceService.isNumericDiceAvailable()"
  (toggled)="!!dice() ? undefined : toggleNumericDice()"
/>
